import styled from 'styled-components';

const BUTTON_SIZE = 31;
const TOP_MARGIN = 10;
const RIGHT_MARGIN = 10;

const getTopMargin = ({ numberOfButtonsTop }) => {
  return numberOfButtonsTop * BUTTON_SIZE + TOP_MARGIN * (2 * numberOfButtonsTop + 1);
};

const getRightMargin = ({ numberOfButtonsRight }) => {
  return numberOfButtonsRight * BUTTON_SIZE + RIGHT_MARGIN * (2 * numberOfButtonsRight + 1);
};

const ButtonOnMap = styled.div`
  position: absolute;
  top: ${props => getTopMargin(props)}px;
  right: ${props => getRightMargin(props)}px;
  z-index: 400;
`;

export default { ButtonOnMap };
